<template>
  <div>
    <tool-bar :title="title"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <div class="margin-top-20">
      <weex-text class="item-sm-bold-heading">{{ otpLabel }}</weex-text>

      <div class="input_container">
        <weex-text class="input_label">OTP</weex-text>
        <input
            class="input_with_border_bottom"
            type="password"
            maxlength="6"
            :value="otp"
            @input="otp=$event.target.value">
      </div>

      <div class="margin-top-10 margin-left-10 margin-right-10">
        <weex-text>
          <span class="font-size-sm text-color-blue">Did not receive OTP?</span>
          <span
              v-if="!countdownCompleted"
              class="font-size-sm text-color-blue">&nbsp;Resend OTP in
                </span>
          <span
              v-if="!countdownCompleted"
              class="font-size-sm text-color-blue">{{ countdownRemainingSeconds }} second(s).
                </span>
          <span
              @click="onResendOTPClicked"
              v-if="countdownCompleted"
              class="item-sm-link">Click here
                </span>
          <span
              v-if="countdownCompleted"
              class="font-size-sm text-color-blue">to resend OTP.
                </span>
        </weex-text>
        <wxc-countdown
            v-if="!countdownCompleted"
            v-show="false"
            tpl="{s}"
            :time="countDowntime"
            @wxcOnComplete="countdownCompleted=true"
            @countdownDetails="countdownRemainingSeconds=$event.second"
        ></wxc-countdown>
      </div>

      <wxc-button
          text="Submit"
          class="horizontal-center margin-top-20"
          type="blue"
          @wxcButtonClicked="onSubmitClicked"
      ></wxc-button>
    </div>
  </div>
</template>
<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import RefreshItem from "../layout/RefreshItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import StageCommentItem from "../layout/StageCommentItem";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import AlertService from "../core/alert/AlertService";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import {EntityType} from "../../utils/EntityType";
import {Activities} from "../../utils/ActivityNavigator";
import {DefaultResourceConfig} from "../../utils/ImageResourcesUtil";
import AttributeUtil, {AttributeDetails} from "../../utils/AttributeUtil";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import {LoanStageConfigKeys} from "../../utils/LoanStageConfigKeys";
import WxcCountdown from "../../../weex-ui/packages/wxc-countdown/index";
import {MessageConstants} from '../../utils/MessageConstantUtil';

export default {
  name: "BankOtpActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    WxcButton,
    Loading,
    StageCommentItem,
    RefreshItem,
    ErrorAlertItem,
    WxcCountdown
  },
  data: () => ({
    title: "Bank OTP",
    showRefreshItem: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    otp: "",
    countdownCompleted: false,
    countdownRemainingSeconds: "",
    countDowntime: 0,
    callAndVerifyCountdownCompleted: false,
    callAndVerifyCountdownRemainingSeconds: "",
    callAndVerifyCountdownTime: "",
    resendOTPTime: 30 * 1000 //30 seconds
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    onSubmitClicked() {
      if (this.checkForValidation()) {
        this.loading = true;
        DataSource.createOrUpdateAttribute(
            AttributeUtil.getAttributeUpdateDto(
                EntityType.LOANS,
                LoanScopeDataHolder.getLoanId(),
                AttributeUtil.getSingleAttributeData(
                    AttributeDetails.BANK_OTP.key,
                    AttributeDetails.BANK_OTP.name,
                    this.otp
                )
            )
        )
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          } else {
            this.completeCurrentTaskAndGetNextTask();
          }
        })
      }
    },

    checkForValidation() {
      if (!this.otp || isNaN(this.otp)) {
        this.showToast("Please Enter Valid OTP");
        return false;
      }
      return true;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res.data);
        }
      });
    },

    onResendOTPClicked() {
      this.loading = true;
      DataSource.resendBankOtp(LoanScopeDataHolder.getLoanId())
      .then(sendOTPRes => {
        this.loading = false;
        if (sendOTPRes.errorOccurred) {
          this.showError(sendOTPRes.data);
        } else {
          this.showSMSOTPView();
          this.showToast(MessageConstants.OTP_SENT_MESSAGE);
        }
      });
    },

    showSMSOTPView() {
      this.otp = "";
      this.countdownCompleted = false;
      this.countdownRemainingSeconds = "";
      this.countDowntime = new Date().getTime() + this.resendOTPTime;
      if (!this.callAndVerifyCountdownTime) {
        this.callAndVerifyCountdownTime = new Date().getTime() + this.callAndVerifyTime;
      }
    },

  },

  created: function () {
    //TODO Fetch Intial properties, if required
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.BANK_OTP];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name
          : "";
    },

    otpLabel() {
      return "Please enter OTP provided by bank";
    }
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>

